<div class="release-config-modal">

    <div class="release-config-modal__header-container">
      <div class="release-config-modal__header-container__header lx-section-title">{{ headerText }}</div>
      <div class="release-config-modal__header-container__close" (click)="close()"><i class="lx-icon lx-close-x"></i></div>
    </div>

    <div class="release-config-modal__body lx-body">
    <span>CONFIGURATION</span>
      <div class="release-config-modal__input-container lx-body">
      {{ bodyText}}
      </div>
    </div>

    <div class="release-config-modal__footer">
      <button class="release-config-modal__footer__close lx-btn lx-btn-secondary"
        (click)="close()">
        <span>Close</span>
      </button>
    </div>

  </div>
